import { useAmp } from 'next/amp'
import Image from 'next/image'
import useAppRouter from '../../hooks/useAppRouter'
import { useTranslation } from '../../hooks/useTranslation'
import { LINK_URL_LOGIN, LINK_URL_ROOT, LINK_URL_EMPLOYER_CONTACT, LINK_URL_CANDIDATE } from '../../utillities/LinkURL'
import ChangeLanguageDropdown from '../ChangeLanguageDropdown'
import LinkWrapper from '../Link'
import ICON_ARROW_RIGHT_BLUE from './assets/arrow-right-blue.svg'
import ICON_BUILDINGS from './assets/buildings.svg'
import SideBarEmployer from '../SidebarEmployer'

import LOGO_EN from './assets/logo_employer_en.svg'
import LOGO_VN from './assets/logo_employer_vn.svg'
import useCurrentEmployer from '../../hooks/useCurrentEmployer'
import useIsLogin from '../../hooks/useIsLogin'
import { useEffect, useRef, useState } from 'react'

const LoginLink = () => {
  const { translate } = useTranslation()
  const [user] = useCurrentEmployer()
  const isLogin = useIsLogin()
  const [isHeaderVisible, setIsHeaderVisible] = useState(false)
  useEffect(() => {
    if (!isLogin) {
      setIsHeaderVisible(true)
    }
  }, [user])
  return (
    <div className={`header-sign-in-up ${isHeaderVisible && 'header-visit'}`}>
      <LinkWrapper prefetch={false} href={LINK_URL_LOGIN} as={LINK_URL_LOGIN}>
        <a>{translate('header:login')}</a>
      </LinkWrapper>
    </div>
  )
}

const DesktopHeaderEmployer = ({ scrollToContactFormProps }) => {
  const router = useAppRouter()
  const isAmp = useAmp()
  const ref = useRef()
  const { translate, currentLanguage } = useTranslation()
  const [showBg, setShowBg] = useState(false)
  const handleScrollToContactForm = () => {
    if (scrollToContactFormProps?.scrollEmitter) {
      scrollToContactFormProps.scrollEmitter()
    } else {
      // window.location.href = LINK_URL_EMPLOYER_CONTACT
    }
  }

  useEffect(() => {
    function updateScrollPosition() {
      const isTop = window.scrollY !== 0
      if (isTop !== showBg) setShowBg(isTop)
    }

    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', updateScrollPosition, false)
      return function cleanup() {
        window.removeEventListener('scroll', updateScrollPosition, false)
      }
    }
  }, [showBg])

  return (
    <div ref={ref} className={`header header-hide-mobile ${showBg ? 'header-bg' : ''}`}>
      <div className="left-group">
        <LinkWrapper prefetch={false} href={LINK_URL_ROOT} as={LINK_URL_ROOT}>
          <a className="header-logo-img">
            <div className="logo-freec">
              {currentLanguage === 'en' ? (
                isAmp === true ? (
                  <div style={{ width: 110, height: 34, margin: 'auto' }}>
                    <amp-img width={120} height={34} src={LOGO_EN?.src} alt="freec-platform" layout="responsive" />
                  </div>
                ) : (
                  <img style={{ display: 'block' }} src={LOGO_EN.src} alt="freec-platform" width={110} height={34} />
                )
              ) : isAmp === true ? (
                <div style={{ width: 150, height: 34, margin: 'auto' }}>
                  <amp-img width={150} height={34} src={LOGO_VN?.src} alt="freec-platform" layout="responsive" />
                </div>
              ) : (
                <Image src={LOGO_VN} alt="freec-platform" width={150} height={34} />
              )}
            </div>
          </a>
        </LinkWrapper>

        <div className="header-link-group">
          <a
            onClick={() => handleScrollToContactForm()}
            className={`header-link ${router.pathname === LINK_URL_EMPLOYER_CONTACT ? 'active' : ''}`}>
            {translate('footer:contact_us')}
          </a>
        </div>
      </div>
      {!isAmp && (
        <div className="right-group">
          <LoginLink />

          <ChangeLanguageDropdown />
          <div className="header-employer">
            <LinkWrapper prefetch={false} href={LINK_URL_CANDIDATE} as={LINK_URL_CANDIDATE}>
              <a className="btn row align-items-center">
                <div className="icon-left d-flex align-items-center justify-content-center">
                  <Image src={ICON_BUILDINGS} alt="freec-platform" width={40} height={40} />
                </div>
                <div className="btn-info">
                  <div className="title">{translate('header:for_job_seeker')}</div>
                  <div className="sub-title">{translate('header:btn_job_seeker_sub')}</div>
                </div>
                <div className="icon-right">
                  <Image src={ICON_ARROW_RIGHT_BLUE} alt="freec-platform" width={24} height={24} />
                </div>
              </a>
            </LinkWrapper>
          </div>
        </div>
      )}
    </div>
  )
}

const HeaderEmployer = ({ scrollToContactFormProps = undefined }) => {
  // if (window.innerWidth <= 1023.98 || window.outerWidth <= 1023.98) {
  //   return <Sidebar isClient={isClient} />
  // }

  return (
    <>
      <DesktopHeaderEmployer scrollToContactFormProps={scrollToContactFormProps} />
      <SideBarEmployer scrollToContactFormProps={scrollToContactFormProps} />
    </>
  )
}

export default HeaderEmployer
